import { Card } from 'antd';
import { ReactNode } from 'react';

import { ResultPageDocument } from '../../defs/types';
import ReceiptTable from '../ReceiptTable';
import { DocumentDualReceiptEntity } from './types';

export function expandDualReceiptTable(record: ResultPageDocument<DocumentDualReceiptEntity>): ReactNode {
  if (record.error) {
    return;
  }
  return (
    <>
      {record.latest_revision.receipts.map((receipt, receiptIndex) => (
        <Card key={receiptIndex}>
          <ReceiptTable receipt={receipt} />
        </Card>
      ))}
    </>
  );
}
